
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/manage-groups/jst/groupUsers';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"no-results-wrapper\">\n    <div class=\"no-results hidden\">\n      ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(4, program4, data),fn:self.program(2, program2, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    </div>\n    <div class=\"invalid-filter hidden\">\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.greater_than_three", "Please enter a search term with three or more characters", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.greater_than_three", "Please enter a search term with three or more characters", options)))
    + "\n    </div>\n  </div>\n  <ul class=\"collectionViewItems unstyled\"></ul>\n  <div class=\"paginatedLoadingIndicator\"></div>\n";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.no_matching_students", "No matching students.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.no_matching_students", "No matching students.", options)))
    + "\n      ";
  return buffer;
  }

function program4(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.no_matching_users", "No matching users.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.no_matching_users", "No matching users.", options)))
    + "\n      ";
  return buffer;
  }

function program6(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n  <div class=\"no-results\">\n    ";
  stack1 = (helper = helpers.ifEqual || (depth0 && depth0.ifEqual),options={hash:{},inverse:self.program(10, program10, data),fn:self.program(7, program7, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options) : helperMissing.call(depth0, "ifEqual", ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.group_user_type), "student", options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n";
  return buffer;
  }
function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.no_students", "There are currently no students in this group.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.no_students", "There are currently no students in this group.", options)))
    + "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(8, program8, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program8(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.add_student", "Add a student to get started.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.add_student", "Add a student to get started.", options)))
    + "\n      ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.no_users", "There are currently no users in this group.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.no_users", "There are currently no users in this group.", options)))
    + "\n      ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.locked), {hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n        "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("groups.manage.group_users")
  },data:data},helper ? helper.call(depth0, "groups.manage.group_users.add_user", "Add a user to get started.", options) : helperMissing.call(depth0, "t", "groups.manage.group_users.add_user", "Add a user to get started.", options)))
    + "\n      ";
  return buffer;
  }

  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, (depth0 && depth0.count), (depth0 && depth0.loading), options) : helperMissing.call(depth0, "ifAny", (depth0 && depth0.count), (depth0 && depth0.loading), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n";
  return buffer;
  });
    ;
    
    import brandableCss from '@canvas/brandable-css';

    brandableCss.loadStylesheetForJST({
      id: '61',
      bundle: 'jst/groups/manage/groupUsers'
    });
  ;
    export default templates[name];
  